import { Pagination } from '@/domain/entities/Pagination'

export class ImageData {
  public id: number
  public name: string
  public category: string
  public link: string
  public createdAt: string
  public updatedAt: string

  constructor(
    id: number,
    name: string,
    category: string,
    link: string,
    createdAt: string,
    updatedAt: string
  ) {
    this.id = id
    this.name = name
    this.category = category
    this.link = link
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }
}

export class Image {
  public success: boolean
  public message: string
  public ids: any
  public pagination?: Pagination
  public data?: ImageData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: ImageData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
